import * as x from '../helpers/xmlHelpers';
import { Property } from './property';

export class SubjectProperty extends Property {
    constructor(doc) {
        super(doc);

        this.propertyValuationMethodType = null;

        const valuationMethod = x.selectSingleNode(doc, "./ns:PROPERTY_VALUATIONS/ns:PROPERTY_VALUATION/ns:PROPERTY_VALUATION_DETAIL");
        if (valuationMethod) {
            this.propertyValuationMethodType = x.getStringElement(valuationMethod, "ns:PropertyValuationMethodType");
        }
    }
}

